import { PRINT_BODY_ID, PRINT_HEADER_ID } from '@/shared/lib/print';

// Shared by every printed training record (DA18.7 matrix report, RQ18.1 training control),
// which are all built as a bordered card of gray-02 rules.
// border-gray-02 (#e3e3e3) is too pale to survive print/PDF color reproduction, so the
// printed record darkens it to the same tone already used by the DA18.7 header table.
// The on-screen card's outer rounded border is on the container we split header/body
// out of, so it never reaches the print window either — reapplied here directly on the
// two repeating print regions so the side/top/bottom lines still frame the record.
export function buildTrainingRecordPrintStyleOverrides(): string {
  return `
    <style>
      #${PRINT_HEADER_ID},
      #${PRINT_BODY_ID} {
        --color-gray-02: var(--color-gray-400);
      }

      #${PRINT_HEADER_ID} {
        border: 1px solid var(--color-gray-400);
        border-bottom: none;
      }

      #${PRINT_BODY_ID} {
        border-left: 1px solid var(--color-gray-400);
        border-right: 1px solid var(--color-gray-400);
        border-bottom: 1px solid var(--color-gray-400);
      }
    </style>
  `;
}
